/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Teamsettings1Inputs */

const en_entity_teamsettings1 = /** @type {(inputs: Entity_Teamsettings1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team Settings`)
};

const de_entity_teamsettings1 = /** @type {(inputs: Entity_Teamsettings1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einstellungen`)
};

/**
* | output |
* | --- |
* | "Team Settings" |
*
* @param {Entity_Teamsettings1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_teamsettings1 = /** @type {((inputs?: Entity_Teamsettings1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Teamsettings1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_teamsettings1(inputs)
	return de_entity_teamsettings1(inputs)
});
export { entity_teamsettings1 as "entity_teamSettings" }